import { useEffect } from 'react'
import PropTypes from 'prop-types'


// when listing/building url contains agent_id, update myAgent with agent_id
// agent_id added from listing/building alert
const UpdateMyAgent = ({ userIsAuthentificated, lastSearchObj, getMyAgent }) => {
  useEffect(() => {
    if(lastSearchObj.identity_token) {
      getMyAgent({ identityToken: lastSearchObj.identity_token })
    }
  }, [userIsAuthentificated])
  return null
}

UpdateMyAgent.propTypes = {
  userIsAuthentificated: PropTypes.bool,
  lastSearchObj: PropTypes.shape({
    identity_token: PropTypes.string,
  }),
  getMyAgent: PropTypes.func,
}

export default UpdateMyAgent
